/**
 * login
 */

export default [{
  name: 'businessManagement',
  path: '/businessManagement',
  menuName: '企业管理',
  menuUrl: '/businessManagement',
  image: 'image/home/home-4',
  permissions: '企业管理',
  redirect: '/businessManagement/staffManagement',
  isParent: true,
  meta: {
    keepAlive: true,
    title: '企业管理',
    href: '/businessManagement',
    redirect: 'noredirect',
    notPage: true, // 没有页面的根路由
    isTab: true,
    rank: 1
  },
  component: () => import( /* webpackChunkName: 'staffManagement' */ '@/views/businessManagement'),
  children: [{
    name: 'staffManagement',
    path: '/businessManagement/staffManagement',
    menuUrl: '/businessManagement',
    menuName: '员工与部门',
    image: 'image/icon_employees_department',
    icon: 'iconicon_department_employees',
    permissions: ['用户管理', '部门管理'],
    meta: {
      title: '员工与部门',
      href: '/staffManagement',
      isTab: true,
      redirect: 'noredirect'
    },
    component: () => import( /* webpackChunkName: 'staffManagement' */ '@/views/businessManagement/staffManagement'),
  },
  {
    name: 'jobLevel',
    path: '/businessManagement/jobLevel',
    menuUrl: '/businessManagement',
    menuName: '职位管理',
    image: 'image/icon_position_management',
    icon: 'iconicon_position_management',
    permissions: '岗位管理',
    meta: {
      title: '职位管理',
      href: '/jobLevel',
      isTab: true,
      redirect: 'noredirect'
    },
    component: () => import( /* webpackChunkName: 'jobLevel' */ '@/views/businessManagement/jobLevel'),
  },
  {
    name: 'leave',
    path: '/businessManagement/leave',
    menuUrl: '/businessManagement',
    menuName: '离职管理',
    image: 'image/icon_leave_management',
    icon: 'iconicon_leave_management',
    meta: {
      title: '离职管理',
      href: '/leave',
      isTab: true,
      redirect: 'noredirect'
    },
    component: () => import( /* webpackChunkName: 'leave' */ '@/views/businessManagement/leave'),
  }]
}
];
